import React, {ReactNode, useCallback, useEffect} from "react";
import axios from "axios";
import {axiosInstance} from "../../../../Service/Axios";
import {useAuthStore} from "../../../../Stores/CoreAndIntegration/useAuthStore";
import {showAlert} from "../../../../Common/Components/BaseComponents/ShowAlert";

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({children}) => {
    const {setUser, clearUser, setLoading, setSessionId} = useAuthStore();

    const verifyFunction = useCallback(async () => {
        try {
            setLoading(true);
            let res = await axiosInstance.get("/auth/verify");
            if (res.status === 200) {
                console.log("Authenticated successfully");
                const data = res.data;
                console.log("User data in authProvider:", data);
                setUser(data.user.user);
                setSessionId(data.user.sessionId);
                return;
            }
            clearUser();
        } catch (err: any) {
            if (axios.isAxiosError(err) && err.response?.status === 401) {
                const data = err.response.data;
                if (data.error === 'TokenExpired') {
                    console.log(" Token expired, trying to refresh...");
                    try {
                        const refreshRes = await axiosInstance.post("/auth/refresh");
                        if (refreshRes.status === 200) {
                            console.log("Refresh token success");
                            const res = await axiosInstance.get("/auth/verify");
                            if (res.status === 200) {
                                const data = res.data;
                                setUser(data.user.user);
                                return;
                            }
                        }
                    } catch (refreshErr) {
                        console.warn(" Refresh token failed", refreshErr);
                    }
                }
            }
            if (axios.isAxiosError(err) && err.response?.status === 409) {
                console.warn("Session ID mismatch - logging out.");
                await showAlert("", "התחברת ממכשיר אחר , אנא התחבר שוב!", "error");
            }
            clearUser();
        } finally {
            setLoading(false);
        }
    }, [setUser, setLoading, clearUser, setSessionId]);

    useEffect(() => {
        const checkAuth = async () => {
            await verifyFunction();
        };
        checkAuth();
    }, [verifyFunction]);

    return <>{children}</>
}